module.exports = __webpack_public_path__ + "img/Ceria by BRI.82fd1ab9.png";